
import angular from 'angular';

import Chart from 'chart.js';

import doughnutTextInside from './doughnut-text-inside';

export default angular.module('directive.doughnut-text-inside', [])
	.controller('doughnutTextInsideController', function() {})
	.directive('doughnutTextInside', doughnutTextInside)
	.name;



// WEBPACK FOOTER //
// ./src/directive/doughnut-text-inside/index.js